import React from 'react'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import useMessage from 'App/hooks/useMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import CheckIcon from 'react-icons/lib/md/check'
import {inboxQueries} from 'src/App/Pages/Inbox/queries'

export default function Close(props) {
  const {conversation} = props
  const mutate = useMutate()
  const showMessage = useMessage()
  const closeConversation = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation closeConversation($conversationId: ID) {
            closeConversation(conversationId: $conversationId) {
              _id
              closedAt
            }
          }
        `,
        variables: {conversationId: conversation._id},
        refetchQueries: inboxQueries
      })
      showMessage('Conversación completada')
    } catch (error) {
      showMessage(error)
    }
  }
  return (
    <div>
      <Button
        disabled={!!conversation.closedAt}
        danger
        confirmText="Confirmar"
        icon={CheckIcon}
        onClick={closeConversation}>
        Completar conversación
      </Button>
    </div>
  )
}
